import { KpopStudyPageTemplate } from "@/components/KpopStudyPageTemplate";

const StudyWithTXT = () => {
  return (
    <KpopStudyPageTemplate
      groupName="TXT"
      groupNameDisplay="TXT"
      fandomName="MOAs"
      seoTitle="Study With TXT - Tomorrow X Together Study Rooms"
      seoDescription="Study with TXT fans worldwide. Join MOAs in virtual study rooms with TXT playlists and productivity tools."
      seoKeywords="study with txt, txt study room, moa study, kpop study room, tomorrow x together"
      canonicalUrl="/study-with-txt/"
      heroDescription="Join a global community of MOAs who combine their passion for TXT with productive study sessions."
      aboutContent={
        <>
          <p>
            <a href="https://txt.bighitmusic.com/" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">TXT (Tomorrow X Together)</a> is a South Korean boy band formed by <a href="https://www.bighitmusic.com/" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">BIGHIT MUSIC</a> in 2019. Members Soobin, Yeonjun, Beomgyu, Taehyun, and Huening Kai have captivated fans with their dreamy concepts.
          </p>
          <p>
            TXT's fanbase, known as MOA (Moments of Alwaysness), represents the bond between the group and their fans. Follow them on <a href="https://www.instagram.com/txt_bighit/" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">Instagram</a>, <a href="https://twitter.com/TXT_members" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">X (Twitter)</a>, and <a href="https://www.youtube.com/@TXT" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">YouTube</a>.
          </p>
        </>
      }
      riseOfContent={
        <p>
          TXT fans have created spaces to combine their passion with productive study sessions, playing <a href="https://open.spotify.com/artist/0ghlgldX5Dd6720Q3qFyQB" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">TXT's music on Spotify</a> in the background.
        </p>
      }
      featureCards={[
        { title: "TXT Study Playlists", desc: "Curated playlists featuring TXT's music to keep you motivated." },
        { title: "Connect with MOA", desc: "Meet fellow MOAs from around the world who share your passion." },
        { title: "Dreamy Study Rooms", desc: "Study rooms with TXT-inspired ethereal and dreamy aesthetics." },
        { title: "Blue Hour Sessions", desc: "Study during the magical blue hour with other MOAs worldwide." },
      ]}
      whyPerfectDescription="CSW is more than just a study platform; it's a place where fans of TXT can come together, stay motivated, and achieve their goals."
      communityDescription1="CSW – Chill Study Work is more than just a study platform; it's a place to connect with like-minded individuals."
      communityDescription2="Discover how studying with your favorite idols can transform your academic journey."
      socialLinks={[
        { name: "Official Website", url: "https://txt.bighitmusic.com/" },
        { name: "YouTube", url: "https://www.youtube.com/@TXT" },
        { name: "Instagram", url: "https://www.instagram.com/txt_bighit/" },
        { name: "X (Twitter)", url: "https://twitter.com/TXT_members" },
        { name: "Spotify", url: "https://open.spotify.com/artist/0ghlgldX5Dd6720Q3qFyQB" },
      ]}
      youtubeVideos={[
        { id: "W3iSnJ663II", title: "TXT - Sugar Rush Ride M/V" },
        { id: "d5bbqKYu51w", title: "TXT - 0X1=LOVESONG M/V" },
        { id: "Yhi4btTM2yE", title: "TXT - Back for More M/V" },
        { id: "Jby-v3Ivjmk", title: "TXT - Chasing That Feeling M/V" },
        { id: "W9Pq83sLwsY", title: "TXT - GGUM M/V" },
        { id: "L-rhT2eLcM8", title: "TXT - Blue Hour M/V" },
      ]}
      youtubeChannelUrl="https://www.youtube.com/@TXT"
      youtubeChannelName="TXT"
    />
  );
};

export default StudyWithTXT;
